<!-- PAGE LOADER -->
<div class="page-progress">
  <mat-progress-bar mode="indeterminate" *ngIf="moduleLoading"></mat-progress-bar>
</div>

<div class="content-grid" *ngIf="!currencyLoading && !educationCenterLoading">
  <div class="app-hub-content {{ forExtract?'bg_gradient_purple':''}}">
    <div class="app-sidebar-container" [ngClass]="{'full-width': !navService.sidebarState.sidenavOpen}">
      <!-- Sidebar -->
      <div class="app-sidebar-wrap">
        <app-sidebar [logo]="logo" class="sidebar-wrapper"></app-sidebar>
      </div>
      <!-- Content page -->
      <div class="app-content-wrap">
        <!-- Header -->
        <app-header [logo]="logo" [forExtract]="forExtract"></app-header>
        <div class="app--body-container" [class.py-0]="hideFooter">
          <router-outlet></router-outlet>
        </div>
        <app-footer *ngIf="!hideFooter"></app-footer>
      </div>
    </div>
  </div>
</div>
<!-- <app-chatbot></app-chatbot> -->
<!-- PAGE LOADER -->
<!-- <div class="page-loader" *ngIf="moduleLoading">
  <mat-spinner class="m-auto"></mat-spinner>
</div> -->